import type { NumberSpeller } from './types'

// Gujarati has an irregular word for every number 0–99.
const BELOW_100 = [
  'શૂન્ય', 'એક', 'બે', 'ત્રણ', 'ચાર', 'પાંચ', 'છ', 'સાત', 'આઠ', 'નવ',
  'દસ', 'અગિયાર', 'બાર', 'તેર', 'ચૌદ', 'પંદર', 'સોળ', 'સત્તર', 'અઢાર', 'ઓગણીસ',
  'વીસ', 'એકવીસ', 'બાવીસ', 'તેવીસ', 'ચોવીસ', 'પચ્ચીસ', 'છવ્વીસ', 'સત્તાવીસ', 'અઠ્ઠાવીસ', 'ઓગણત્રીસ',
  'ત્રીસ', 'એકત્રીસ', 'બત્રીસ', 'તેત્રીસ', 'ચોત્રીસ', 'પાંત્રીસ', 'છત્રીસ', 'સાડત્રીસ', 'આડત્રીસ', 'ઓગણચાલીસ',
  'ચાલીસ', 'એકતાલીસ', 'બેતાલીસ', 'તેતાલીસ', 'ચુમ્માલીસ', 'પિસ્તાલીસ', 'છેતાલીસ', 'સુડતાલીસ', 'અડતાલીસ', 'ઓગણપચાસ',
  'પચાસ', 'એકાવન', 'બાવન', 'ત્રેપન', 'ચોપન', 'પંચાવન', 'છપ્પન', 'સત્તાવન', 'અઠ્ઠાવન', 'ઓગણસાઠ',
  'સાઠ', 'એકસઠ', 'બાસઠ', 'ત્રેસઠ', 'ચોસઠ', 'પાંસઠ', 'છાસઠ', 'સડસઠ', 'અડસઠ', 'ઓગણસિત્તેર',
  'સિત્તેર', 'એકોતેર', 'બોતેર', 'તોતેર', 'ચુમોતેર', 'પંચોતેર', 'છોતેર', 'સિત્યોતેર', 'ઇઠ્યોતેર', 'ઓગણએંશી',
  'એંશી', 'એક્યાસી', 'બ્યાસી', 'ત્યાસી', 'ચોર્યાસી', 'પંચાસી', 'છ્યાસી', 'સિત્યાસી', 'ઇઠ્યાસી', 'નેવ્યાસી',
  'નેવું', 'એકાણું', 'બાણું', 'ત્રાણું', 'ચોરાણું', 'પંચાણું', 'છન્નું', 'સત્તાણું', 'અઠ્ઠાણું', 'નવ્વાણું'
]

// Hundreds join "સો": એકસો, બસો, ત્રણસો, … ઓગણીસસો. 100 alone is just "સો".
function hundreds(h: number, r: number): string {
  if (h === 1 && r === 0) return 'સો'
  if (h === 2) return 'બસો'
  return `${BELOW_100[h]}સો`
}

function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  return [h ? hundreds(h, r) : '', r ? BELOW_100[r] : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return BELOW_100[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'કરોડ'], [100_000, 'લાખ'], [1000, 'હજાર']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const gu: NumberSpeller = {
  spell,
  // 1100–1999 are said in hundreds ("ઓગણીસસો પંચાસી"); other years as plain numbers.
  year: (n) => (n >= 1100 && n < 2000
    ? [`${BELOW_100[Math.floor(n / 100)]}સો`, n % 100 ? BELOW_100[n % 100] : ''].filter(Boolean).join(' ')
    : spell(n)),
  rupees: 'રૂપિયા'
}
